import axios from "axios";
import {LOGIN_URL} from "../constants/urlConfig";

const API_URL = process.env.REACT_APP_API_URL || '';

const axiosWithNoAuthHeaders = axios.create({
    baseURL: API_URL
});

const axiosWithHeaders = axios.create({
    baseURL: API_URL
});

class Api {
    static login(user) {
        return axiosWithNoAuthHeaders.post(LOGIN_URL, user);
    }

    static post(url, payload) {
        return axiosWithHeaders.post(url, payload);
    }

    static put(url, payload) {
        return axiosWithHeaders.put(url, payload);
    }

    static get(url) {
        return axiosWithHeaders.get(url);
    }

    static delete(url) {
        return axiosWithHeaders.delete(url);
    }
}

export default Api;

export {axiosWithHeaders};
